(function () {
  var KS_PATH =
    'M7.168 0c-3.2 0-5.797 2.579-5.797 5.758v12.484C1.371 21.42 3.968 24 7.168' +
    ' 24c1.981 0 3.716-.978 4.768-2.479l.794.79c2.26 2.245 5.943 2.245 8.203 0a5.724' +
    ' 5.724 0 001.696-4.075 5.724 5.724 0 00-1.696-4.074l-2.182-2.168 2.182-2.156a5.724' +
    ' 5.724 0 001.696-4.074 5.724 5.724 0 00-1.696-4.074c-2.26-2.246-5.942-2.246-8.203' +
    ' 0l-.794.789A5.797 5.797 0 007.168 0Z';

  var SVG_ATTRS =
    'width="11" height="11" viewBox="0 0 24 24"' +
    ' style="display:inline-block;vertical-align:middle;margin-right:4px;flex-shrink:0;position:relative;top:-1px"';

  var TOKENS = {
    '[clock]':
      '<svg ' + SVG_ATTRS + ' fill="none" stroke="rgba(255,255,255,0.3)"' +
      ' stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>',
    '[ks-green]':
      '<svg ' + SVG_ATTRS + ' fill="#05ce78"><path d="' + KS_PATH + '"/></svg>',
    '[ks-white]':
      '<svg ' + SVG_ATTRS + ' fill="rgba(255,255,255,0.85)"><path d="' + KS_PATH + '"/></svg>'
  };

  var TOKEN_RE = /\[clock\]|\[ks-green\]|\[ks-white\]/;
  var SKIP = { SCRIPT: 1, STYLE: 1, NOSCRIPT: 1, TEXTAREA: 1, IFRAME: 1 };

  function processText(raw) {
    var out = raw;
    for (var tok in TOKENS) {
      if (out.indexOf(tok) !== -1) {
        out = out.split(tok).join(TOKENS[tok]);
      }
    }
    return out;
  }

  function walk(node) {
    if (node.nodeType === 3) {
      if (TOKEN_RE.test(node.nodeValue)) {
        var wrap = document.createElement('span');
        wrap.innerHTML = processText(node.nodeValue);
        node.parentNode.replaceChild(wrap, node);
      }
    } else if (node.nodeType === 1 && !SKIP[node.tagName]) {
      var kids = Array.prototype.slice.call(node.childNodes);
      for (var i = 0; i < kids.length; i++) walk(kids[i]);
    }
  }

  // Inject global blur CSS once
  var style = document.createElement('style');
  style.textContent =
    '.np-blr{filter:blur(4px);-webkit-filter:blur(4px);' +
    'user-select:none;-webkit-user-select:none;cursor:default;}';
  document.head.appendChild(style);

  document.addEventListener('DOMContentLoaded', function () {
    walk(document.body);
  });
})();
